import { Component, Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { MensajesFijosEnum } from '../utilerias/enums/mensajes-fijos-enum';
declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class SweetAlertComponent {
    show(type, mensaje) {
        if (type === 'success-message') {
            Swal.fire({
                text: 'Operación exitosa',
                icon: 'success',
                confirmButtonText: 'Aceptar',      // Texto del botón
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                buttonsStyling: false
            })

        } else if (type === 'error-message') {
            Swal.fire({
                text: mensaje != null ? mensaje : 'No se pudo completar la operación',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                confirmButtonText: 'Aceptar',
                icon: 'error',
            });
        } else if (type === 'info-message') {
            Swal.fire({
                text: MensajesFijosEnum.ALERTA_REQUERIDO,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                confirmButtonText: 'Aceptar',
                icon: 'info',
            });
        } else if (type === 'info-message-detail') {
            Swal.fire({
                text: 'Formato inválido: ' + mensaje,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                confirmButtonText: 'Aceptar',
                icon: 'info',
            });
        } else if (type === 'warning-message-and-confirmation') {
            Swal.fire({
                text: mensaje,
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                // cancelButtonClass: 'btn btn-finan-tres',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        text: 'Operación exitosa',
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    });
                }
            });
        } else if (type === 'basic') {
            Swal.fire({
                title: 'Respuesta exitosa',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
            });
        } else if (type === 'warning-message-and-cancel') {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this imaginary file!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                // cancelButtonClass: 'btn btn-finan-tres',
                buttonsStyling: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: 'Deleted!',
                        text: 'Your imaginary file has been deleted.',
                        icon: 'success',
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    });
                } else {
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'Your imaginary file is safe :)',
                        icon: 'error',
                        // confirmButtonClass: 'btn btn-info',
                        buttonsStyling: false,
                    });
                }
            });
        } else if (type === 'custom-html') {
            Swal.fire({
                title: 'Personas',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                html: mensaje,
            });
        } else if (type === 'table') {
            Swal.fire({
                title: 'HTML example',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                html: 'You can use <b>bold text</b>, ' +
                    '<a href="http://github.com">links</a> ' +
                    'and other HTML tags',
            });
        } else if (type === 'auto-close') {
            Swal.fire({
                title: 'Auto close alert!',
                text: 'I will close in 2 seconds.',
                timer: 2000,
                showConfirmButton: false,
            });
        } else if (type === 'input-field') {
            Swal.fire({
                title: 'Input something',
                html: '<div class="form-group">' +
                    '<input id="input-field" type="text" class="form-control" />' +
                    '</div>',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false,  // Desactivar los estilos predeterminados de los botones
            }).then(function (result) {
                if (result.isConfirmed) {
                    const inputValue = (document.getElementById('input-field') as HTMLInputElement).value;

                    Swal.fire({
                        icon: 'success',
                        html: 'You entered: <strong>' + inputValue + '</strong>',
                        buttonsStyling: false,
                    });
                }
            });
        } else if (type === 'info-rule') {
            Swal.fire({
                text: mensaje,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-success',
                },
                confirmButtonText: 'Aceptar',
                icon: 'info',
            });
        }
    }
}
